<template>
  <div class="hello">
    <h1>Exponential-ekvation </h1>
    <p><i>För att lösa uppgiften får godtyckliga hjälpmedel användas inklusive digitala verktyg.</i></p>
    <p><i>Kör man fast trycker man på <b>Tips 1</b>. Om inte det hjälper trycker man på <b>Tips 2</b> o.s.v.</i></p>

    <div class="body-stil">
<div class="uppgiftstext">
    <h3>Uppgift 1</h3>
    <p>
      Lindas mormor sätter in 2000 kr på ett bankkonto vid Lindas födelse. Därefter rörs inte pengarna.</p>
      <p>Räntesatsen är 4,25%</p>
      <p>Hur gammal är Linda när det finns 3000 kr på kontot.</p>
      <br>
      <img src="../assets/sparbanken.jpg" alt="sparbanken">
</div>

</div>

<div id="tips1" class="tips tips1" >
<h3 class="pil" @click="förstora('#tips1')">Tips 1</h3>
<p>Konstruera en exponentialfunktion <b>y = C a <sup>x</sup></b></p>
</div>


<div id="tips2" class="tips tips2" >
<h3  class="pil" @click="förstora('#tips2')">Tips 2</h3>
<p><b>C</b> är startvärde, <b>a</b> är förändringsfaktor, <b>x</b> är tiden</p>
</div>


<div id="tips3" class="tips tips3" >
<h3 class="pil" @click="förstora('#tips3')">Tips 3</h3>
<p>Använd funktionen y = 2000 * 1,0425 <sup>x</sup></p><br>
där <b>y</b> beskriver pengarna på kontot efter <b>x</b> år.

</div>


<div id="tips4" class="tips tips4" >
<h3 class="pil" @click="förstora('#tips4')">Tips 4</h3>
<p>Skriv in funktionerna:  <b>y = 2000 * 1,0425 <sup>x</sup></b> och <b>y = 3000</b> i geogebra</p>
<p> läs av skärningspunkten
</p>
<p>(Du kommer att behöva dra i y-axeln genom att trycka shift + musknapp och dra samtidigt) </p>
<p><b>eller...</b> </p>
</div>

<div id="tips5" class="tips tips5" >
<h3 class="pil" @click="förstora('#tips5')">Tips 5</h3>
<p>Lös ekvationen<b> 2000 * 1,0425<sup>x</sup> = 3000</b> algebraiskt</p>
</div>

<div id="tips6" class="tips tips6" >
<h3 class="pil" @click="förstora('#tips6')">Tips 6</h3>
<p>Dela först båda sidor med 2000.</p>
<p>Då får du<b> 1,0425<sup>x</sup> = 1,5</b> </p>

<p>Ta sedan logaritmen på båda sidor.</p>
<p>Då får du<b> lg 1,0425<sup>x</sup> = lg 1,5</b> </p>

<p>Det kan skriva om som.</p>
<p>Då får du<b> x * lg 1,0425 = lg 1,5</b> </p>

<p>Dividera båda sidor med <i>lg 1,0425</i> så att x blir ensamt i vänsterledet. Sen använder du miniräknaren.</p>



</div>









<router-link class="länk" to="/exponentialekvation2">
    nästa uppgift ->
</router-link>




  </div>
</template>

<script>
export default {
    name: 'StartPage',
    props: {
        msg: String
    },
    methods: {
        förstora: function(val){
            this.$el.querySelector(val).classList.toggle("tips");
            //document.getElementById("tips1").classList.toggle("tips1");
        }
    },
    created() {
        document.title = 'Exponentialekvation 1';
        const favicon = document.getElementById('favicon');
        favicon.href="../src/assets/bil.ico";
        //favicon.href="https://www.google.com/favicon.ico";

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.uppgiftstext {
    text-align: left;
    color: black;
    background-color: #ffff77;
    border: solid 1px;
    padding-left: 1em;
    border-radius: 5px;
}
.body-stil {
    margin-left:15%;
    margin-right:15%;
}
.tips1 {
    color:darkblue;


}

.tips2 {
    color: #fd2608;
}

.tips3 {
    color:darkblue;

}

.tips4 {

    color:darkgreen;
    dcolor: #f3cb08;
}


.tips6 {

    color:#CC0;
    transition: height 2s;
}
.tips {
    height: 4em;
    overflow-y: hidden;
}

.hello {
    min-height: calc(100vh - 70px);
}


.pil {
    cursor: context-menu;

    -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
}
.pil:hover {
    text-decoration: underline;
}
.länk {
    position: absolute;
    bottom: 4em;
    right: 10px;
    text-decoration: none;
    color: black;
}
.länk:hover {
    text-decoration: underline;
    cursor: context-menu;

    -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
}

img {
    position: absolute;
    top:400px;
    left: 15%;
    width:10%;

}

</style>
